// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


//Test için çalışırken aşağıdaki kodu aktif etmek gerekli.
//export const environment = {
//    production: false,
//    local: true,
//    authTokenKey: 'mbs-token',
//    apiUrl: 'http://localhost:55192/api',
//    signalRUrl: 'http://localhost:55192/mbsHub',
//    signalRStatisticUrl: 'http://localhost:55192/statisticHub',
//};


//Canlıya atarken aşağıdaki kodu aktif etmek gerekli.
export const environment = {
    production: false,
    local: true,
    authTokenKey: 'mbs-token',
    apiUrl: 'https://mezun.ankara.edu.tr/api/api',
    signalRUrl: 'https://mezun.ankara.edu.tr/api/mbsHub',
    signalRStatisticUrl: 'https://mezun.ankara.edu.tr/api/statisticHub',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
